import React from "react";
import { Button, ButtonGrey } from "../../style/Button";
import "./Bill.css";
import AdvertiserCard from "../common/card";
import { Checkbox } from "@material-ui/core";
export class Billing extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: {},
      check1: false,
      check2: false,
      check3: false,
      check4: false,
    };

    this.handleChange = this.handleChange.bind(this);
    this.restoreView = this.restoreView.bind(this);
    this.update = this.update.bind(this);
    this.restoreView();
  }

  handleChange = event => {
    this.setState({ check1: !this.state.check1 });
    if (event.target.checked) {
      if (this.state.value) {
          this.state.value.discount = true;
          window.sessionStorage.setItem("med", JSON.stringify(this.state.value));
        }

      }

  }

  restoreView = () => {
    if (this.props.location.state) {
      this.state.value = this.props.location.state;
      window.sessionStorage.setItem("med", JSON.stringify(this.state.value));
    } else {
      this.state.value = JSON.parse(window.sessionStorage.getItem("med"));
    }
  };

  update = () => {
    this.props.history.push({
      pathname: "/People/Prescription",
    });
  };

  render() {
    return (
      <div style={{ display: "flex" }}>
        <div style={{ width: "85%" }}>
          <section
            class=" mt-3 custom-radius border border-secondary "
            style={{
              paddingBottom: "0px !important",
              backgroundColor: "white",
            }}
          >
            <nav class="navbar navbar-expand-lg  custom-radius  navbar-dark theme-color p-0">
              <a
                class="navbar-brand  ms-4 fw-bold"
                href="#"
                style={{
                  fontSize: "11.5px",
                  fontWeight: 600,
                  fontFamily:
                    "Montserrat, 'Open Sans', Helvetica, Arial, sans-serif",
                }}
              >
                Selected Mediation
              </a>

              <span
                class="collapse navbar-collapse"
                id="navbarNav"
                style={{
                  fontSize: "11.5px",
                  color: "white",
                  fontWeight: 600,
                  fontFamily:
                    "Montserrat, 'Open Sans', Helvetica, Arial, sans-serif",
                }}
              >
                <b>
                  <span
                    style={{
                      position: "absolute",
                      right: "120px",
                      marginTop: "-8px",
                    }}
                  >
                    Monograph
                  </span>{" "}
                  <span
                    style={{
                      marginTop: "-8px",
                      position: "absolute",
                      right: "40px",
                    }}
                  >
                    {" "}
                    Leaflet
                  </span>
                </b>
              </span>
            </nav>
            <nav
              class="navbar navbar-expand-lg border    navbar-primary bg-white "
              style={{ paddingTop: "2px", paddingBottom: "2px" }}
            >
              <a
                style={{
                  fontSize: "16.6px",
                  fontWeight: 600,
                  fontFamily:
                    "Montserrat, 'Open Sans', Helvetica, Arial, sans-serif",
                }}
                class="navbar-brand  ms-4"
                href="#"
              >
                {this.state.value.medicationName}{" "}
              </a>

              <div
                class="collapse navbar-collapse"
                id="navbarNav"
                style={{ marginRight: "35px" }}
              >
                <ul
                  class="navbar-nav ms-auto "
                  style={{ fontSize: "11px", color: "#606060" }}
                >
                  <li class="nav-item" style={{ padding: 5 }}>
                    <b
                      style={{
                        fontWeight: 700,
                        fontFamily:
                          "Montserrat, 'Open Sans', Helvetica, Arial, sans-serif",
                      }}
                    >
                      Type:{" "}
                    </b>{" "}
                    <span
                      class="text-secondary"
                      style={{
                        fontWeight: 500,
                        fontFamily:
                          "Montserrat, 'Open Sans', Helvetica, Arial, sans-serif",
                      }}
                    >
                      Brand Rx
                    </span>
                  </li>
                  <li class="nav-item" style={{ padding: 5 }}>
                    <b
                      style={{
                        fontWeight: 700,
                        fontFamily:
                          "Montserrat, 'Open Sans', Helvetica, Arial, sans-serif",
                      }}
                    >
                      Formulary:{" "}
                    </b>{" "}
                    <span
                      class="text-secondary"
                      style={{
                        fontWeight: 500,
                        fontFamily:
                          "Montserrat, 'Open Sans', Helvetica, Arial, sans-serif",
                      }}
                    >
                      Un
                    </span>
                  </li>
                  <li
                    class="nav-item"
                    style={{
                      padding: 5,
                      fontWeight: 500,
                      fontFamily:
                        "Montserrat, 'Open Sans', Helvetica, Arial, sans-serif",
                    }}
                  >
                    View Coverage
                  </li>
                </ul>
              </div>
            </nav>
            <nav
              class="navbar navbar-expand-lg border   navbar-primary bg-white "
              style={{ paddingTop: "4px", paddingBottom: "4px" }}
            >
              <div class="collapse navbar-collapse" id="navbarNav">
                <ul
                  class="navbar-nav offset-10 position-relative"
                  style={{ fontSize: "13px", right: "0px" }}
                >
                  <li class="nav-item " style={{ marginTop: "-9px" }}>
                    <div class="nav-link text-dark ">
                      <Checkbox
                        className="clickable2"
                        type="checkbox"
                        onChange={this.handleChange}
                      />
                    </div>
                  </li>
                  <li class="nav-item ms-2">
                    <div
                      class="nav-link text-dark"
                      style={{
                        width: "32px",
                        height: "35px",
                        marginTop: "-3px",
                        fontSize: "20px",
                      }}
                    >
                      <i
                        class="far fa-money-bill-alt"
                        style={{ color: "#008576" }}
                      ></i>
                    </div>
                  </li>
                  <li class="nav-item ms-3">
                    <div
                      class="nav-link "
                      style={{
                        color: "#008576",
                        fontSize: "10px",
                        fontWeight: 500,
                        marginLeft: "7px",
                        fontFamily:
                          "Montserrat, 'Open Sans', Helvetica, Arial, sans-serif",
                      }}
                    >
                      Coupon/guide <br />
                      Available
                    </div>
                  </li>
                  {this.state.check1 && (
                    <span
                      style={{ marginLeft: "-110%", marginTop: "30px" }}
                    ></span>
                  )}
                </ul>
              </div>
            </nav>

            <nav class="navbar navbar-expand-lg   navbar-dark theme-color     p-0  ">
              <a
                class="navbar-brand  ms-4 fw-bolder"
                style={{
                  fontSize: "11.5px",
                  fontWeight: 600,
                  fontFamily:
                    "Montserrat, 'Open Sans', Helvetica, Arial, sans-serif",
                }}
                href="#"
              >
                Sig Information
              </a>
            </nav>

            <div class="d-flex justify-content-evenly p-2 ms-3">
              <button
                type="button"
                class="btn text-dark rounded-2 theme-font"
                style={{
                  backgroundColor: "#e6e6e6",
                  fontFamily:
                    "Montserrat, 'Open Sans', Helvetica, Arial, sans-serif",
                  width: "100%",
                  fontSize: "11px",
                  fontWeight: 600,
                  color: "#58595B",
                  marginRight: "10px",
                }}
              >
                Action
              </button>
              <button
                type="button"
                class="btn text-dark rounded-2 theme-font"
                style={{
                  backgroundColor: "#e6e6e6",
                  fontFamily:
                    "Montserrat, 'Open Sans', Helvetica, Arial, sans-serif",
                  width: "100%",
                  fontSize: "11px",
                  fontWeight: 600,
                  color: "#58595B",
                  marginRight: "10px",
                }}
              >
                Amount
              </button>
              <button
                type="button"
                class="btn text-dark rounded-2 theme-font"
                style={{
                  backgroundColor: "#e6e6e6",
                  fontFamily:
                    "Montserrat, 'Open Sans', Helvetica, Arial, sans-serif",
                  width: "100%",
                  fontSize: "11px",
                  fontWeight: 600,
                  color: "#58595B",
                  marginRight: "10px",
                }}
              >
                Dosage Form
              </button>
              <button
                type="button"
                class="btn text-dark rounded-2 theme-font"
                style={{
                  backgroundColor: "#e6e6e6",
                  fontFamily:
                    "Montserrat, 'Open Sans', Helvetica, Arial, sans-serif",
                  width: "100%",
                  fontSize: "11px",
                  fontWeight: 600,
                  color: "#58595B",
                  marginRight: "10px",
                }}
              >
                Route
              </button>
              <button
                type="button"
                class="btn text-dark rounded-2 theme-font"
                style={{
                  backgroundColor: "#e6e6e6",
                  fontFamily:
                    "Montserrat, 'Open Sans', Helvetica, Arial, sans-serif",
                  width: "100%",
                  fontSize: "11px",
                  fontWeight: 600,
                  color: "#58595B",
                  marginRight: "15px",
                }}
              >
                Frequency
              </button>
            </div>
            <div
              class="d-flex justify-content-evenly p-2 ms-3"
              style={{ marginTop: "7px" }}
            >
              <select
                name=""
                id=""
                class="form-select theme-font"
                aria-label="Default select example"
                style={{
                  width: "100%",
                  marginRight: "10px",
                  fontFamily:
                    "Montserrat, 'Open Sans', Helvetica, Arial, sans-serif",
                  fontSize: "11px",
                  fontWeight: 600,
                  color: "#58595B",
                }}
              >
                <option value="">Take</option>
                <option value=""></option>
              </select>
              <select
                name=""
                id=""
                class="form-select theme-font"
                style={{
                  width: "100%",
                  marginRight: "10px",
                  fontFamily:
                    "Montserrat, 'Open Sans', Helvetica, Arial, sans-serif",
                  fontSize: "11px",
                  fontWeight: 600,
                  color: "#58595B",
                }}
              >
                <option value="">{this.state.value.amount}</option>
              </select>
              <select
                name=""
                id=""
                class="form-select theme-font"
                style={{
                  width: "100%",
                  marginRight: "10px",
                  fontFamily:
                    "Montserrat, 'Open Sans', Helvetica, Arial, sans-serif",
                  fontSize: "11px",
                  fontWeight: 600,
                  color: "#58595B",
                }}
              >
                <option value="">{this.state.value.dosageForm}</option>
              </select>
              <select
                name=""
                id=""
                class="form-select theme-font"
                style={{
                  width: "100%",
                  marginRight: "10px",
                  fontFamily:
                    "Montserrat, 'Open Sans', Helvetica, Arial, sans-serif",
                  fontSize: "11px",
                  fontWeight: 600,
                  color: "#58595B",
                }}
              >
                <option value="">{this.state.value.route}</option>
              </select>
              <select
                name=""
                id=""
                class="form-select theme-font"
                style={{
                  width: "100%",
                  marginRight: "15px",
                  fontFamily:
                    "Montserrat, 'Open Sans', Helvetica, Arial, sans-serif",
                  fontSize: "11px",
                  fontWeight: 600,
                  color: "#58595B",
                }}
              >
                <option value="">{this.state.value.frequency}</option>
              </select>
            </div>
            <div class="mb-3 ms-3 row" style={{ marginTop: "7px" }}>
              <label
                for="add"
                class="col-md-2 col-form-label theme-font"
                style={{
                  maxWidth: "max-content",
                  fontWeight: 600,
                  fontFamily:
                    "Montserrat, 'Open Sans', Helvetica, Arial, sans-serif",
                  color: "#58595B",
                  fontSize: "11px",
                  paddingRight: "0px",
                }}
              >
                Addtional Direction:
              </label>
              <div class="col-md-10" style={{ paddingRight: "35px" }}>
                <input
                  style={{
                    maxWidth: "108.5%",
                    minWidth: "108.5%",
                    marginLeft: "0px",
                    fontFamily:
                      "Montserrat, 'Open Sans', Helvetica, Arial, sans-serif",
                    fontSize: "11px",
                    fontWeight: 600,
                    color: "#58595B",
                  }}
                  type="text"
                  class="form-control theme-font "
                  id="add"
                  value=""
                />
              </div>
            </div>
            <div class="mb-3 ms-3  row">
              <label
                class="col-sm-2 col-form-label theme-font"
                style={{
                  maxWidth: "max-content",
                  fontWeight: 600,
                  fontFamily:
                    "Montserrat, 'Open Sans', Helvetica, Arial, sans-serif",
                  color: "#58595B",
                  fontSize: "11px",
                  paddingRight: "0px",
                }}
              >
                Patient Direction: :
              </label>
              <div class="col-sm-4">
                <textarea
                  style={{
                    maxWidth: "98.5%",
                    minWidth: "fit-content",
                    marginLeft: "10px",
                    fontFamily:
                      "Montserrat, 'Open Sans', Helvetica, Arial, sans-serif",
                    fontSize: "11px",
                    fontWeight: 600,
                    color: "#58595B",
                  }}
                  name=""
                  id=""
                  cols="30"
                  rows="5"
                  class="form-control theme-font"
                >
                  {this.state.value.patientDirection}
                </textarea>
              </div>
              <div class="col-md-4">
                <div class="form-check mt-0 ms-1">
                  <label
                    for=""
                    class="text-secondary ms-3 theme-font"
                    style={{
                      maxWidth: "max-content",
                      fontWeight: 600,
                      fontFamily:
                        "Montserrat, 'Open Sans', Helvetica, Arial, sans-serif",
                      color: "#58595B",
                      fontSize: "11px",
                      paddingRight: "0px",
                    }}
                  >
                    Day Supply:
                    <input
                      style={{
                        width: 170,
                        display: "inline",
                        marginLeft: "58px",
                        fontSize: "12.7px",
                        fontFamily:
                          "Montserrat, 'Open Sans', Helvetica, Arial, sans-serif",
                        fontSize: "11px",
                        fontWeight: 600,
                        color: "#58595B",
                      }}
                      type="text"
                      class="form-control"
                      value={this.state.value.daysSupply}
                    />
                  </label>
                </div>
                <div class="form-check ms-1 mt-3">
                  <label
                    for=""
                    class="text-secondary ms-3 theme-font"
                    style={{
                      maxWidth: "max-content",
                      fontWeight: 600,
                      fontFamily:
                        "Montserrat, 'Open Sans', Helvetica, Arial, sans-serif",
                      color: "#58595B",
                      fontSize: "11px",
                      paddingRight: "0px",
                    }}
                  >
                    Dispence Amount:
                    <input
                      style={{
                        width: 170,
                        display: "inline",
                        marginLeft: "20px",
                        fontSize: "12.7px",
                        fontFamily:
                          "Montserrat, 'Open Sans', Helvetica, Arial, sans-serif",
                        fontSize: "11px",
                        fontWeight: 600,
                        color: "#58595B",
                      }}
                      type="text"
                      class="form-control"
                      value={this.state.value.dispenseAmount}
                    />
                  </label>
                </div>
              </div>
            </div>
            {/* <div class="mb-3 ms-4 row" style={{ marginTop: "-37px" }}>
            <div class="col-md-6"></div>
            <label 
              class="col-sm-1 col-form-label"
              style={{ fontSize: "12px" }}
            >
              Refills:
            </label>
            <div class="col-sm-2">
              <input
                type="text"
                class="form-control"
                id="staticEmail"
                value="0"
              />
            </div>
          </div> */}
            <div class="mb-3 ms-3 row">
              <label
                class="col-md-2 theme-font col-form-label"
                style={{
                  maxWidth: "max-content",
                  fontWeight: 600,
                  fontFamily:
                    "Montserrat, 'Open Sans', Helvetica, Arial, sans-serif",
                  color: "#58595B",
                  fontSize: "11px",
                  paddingRight: "0px",
                }}
              >
                Problem/Dx:
              </label>
              <div class="col-md-10" style={{ paddingRight: "35px" }}>
                <select
                  style={{
                    maxWidth: "108.5%",
                    minWidth: "108%",
                    marginLeft: "45px",
                    fontFamily:
                      "Montserrat, 'Open Sans', Helvetica, Arial, sans-serif",
                    fontSize: "11px",
                    fontWeight: 600,
                    color: "#58595B",
                  }}
                  name=""
                  id=""
                  class="form-select theme-font"
                >
                  <option value="">1</option>
                </select>
              </div>
            </div>
            <div class="mb-3 ms-3  row">
              <label
                class="col-md-2 col-form-label theme-font"
                style={{
                  maxWidth: "max-content",
                  fontWeight: 600,
                  fontFamily:
                    "Montserrat, 'Open Sans', Helvetica, Arial, sans-serif",
                  color: "#58595B",
                  fontSize: "11px",
                  paddingRight: "0px",
                }}
              >
                Pharmacy Notes:
              </label>
              <div class="col-sm-4">
                <textarea
                  style={{
                    maxWidth: "100%",
                    minWidth: "fit-content",
                    marginLeft: "20px",
                    fontFamily:
                      "Montserrat, 'Open Sans', Helvetica, Arial, sans-serif",
                    fontSize: "11px",
                    fontWeight: 600,
                    color: "#58595B",
                  }}
                  name=""
                  id=""
                  cols="30"
                  rows="3"
                  class="form-control theme-font"
                >
                  {this.state.value.pharmacyNote}
                </textarea>
              </div>
              <div class="col-md-4">
                <div class="form-check mt-1 ms-5">
                  <Checkbox
                    style={{ padding: "0px", margin: "-5px" }}
                    type="checkbox"
                    value=""
                    onChange={() =>
                      this.setState({ check2: !this.state.check2 })
                    }
                  />
                  <label
                    for=""
                    class="text-secondary ms-3 theme-font"
                    style={{
                      maxWidth: "max-content",
                      fontWeight: 600,
                      color: "#58595B",
                      fontSize: "11px",
                      paddingRight: "0px",
                      fontFamily:
                        "Montserrat, 'Open Sans', Helvetica, Arial, sans-serif",
                    }}
                  >
                    Store Sig & Add to Prescriber’s List
                  </label>
                </div>
                <div class="form-check ms-5 mt-3">
                  <Checkbox
                    style={{ padding: "0px", margin: "-5px" }}
                    className="clickable2"
                    type="checkbox"
                    value=""
                    onChange={() =>
                      this.setState({ check3: !this.state.check3 })
                    }
                  />
                  <label
                    for=""
                    class="text-secondary ms-3 theme-font"
                    style={{
                      maxWidth: "max-content",
                      fontWeight: 600,
                      color: "#58595B",
                      fontSize: "11px",
                      paddingRight: "0px",
                      fontFamily:
                        "Montserrat, 'Open Sans', Helvetica, Arial, sans-serif",
                    }}
                  >
                    DAW/DNS
                  </label>
                  {this.state.check3 && <span></span>}
                </div>
              </div>
              <nav
                class="navbar navbar-expand-lg navbar-dark theme-color p-0"
                style={{
                  marginLeft: "-16px",
                  marginTop: "7px",
                  minWidth: "100.4%",
                }}
              >
                <a
                  class="navbar-brand  ms-4 fw-bold"
                  href="#"
                  style={{
                    fontSize: "11.5px",
                    fontFamily:
                      "Montserrat, 'Open Sans', Helvetica, Arial, sans-serif",
                    fontWeight: 600,
                  }}
                >
                  Alternative Medication
                </a>
              </nav>

              <nav
                class="navbar navbar-expand-lg border    navbar-primary bg-white "
                style={{ marginLeft: "-16px", minWidth: "100.3%" }}
              >
                <a
                  style={{ fontSize: "16.6px", fontWeight: 600 }}
                  class="navbar-brand  ms-4"
                  href="#"
                >
                  {this.state.value.alternativeMedication}{" "}
                </a>

                <div
                  class="collapse navbar-collapse"
                  id="navbarNav"
                  style={{ marginRight: "35px" }}
                >
                  <ul
                    class="navbar-nav ms-auto "
                    style={{ fontSize: "11px", color: "#606060" }}
                  >
                    <li class="nav-item" style={{ padding: 5 }}>
                      <b
                        style={{
                          fontWeight: 700,
                          fontFamily:
                            "Montserrat, 'Open Sans', Helvetica, Arial, sans-serif",
                        }}
                      >
                        Type:{" "}
                      </b>{" "}
                      <span
                        class="text-secondary"
                        style={{
                          fontWeight: 500,
                          fontFamily:
                            "Montserrat, 'Open Sans', Helvetica, Arial, sans-serif",
                        }}
                      >
                        Brand Rx
                      </span>
                    </li>
                    <li class="nav-item" style={{ padding: 5 }}>
                      <b
                        style={{
                          fontWeight: 700,
                          fontFamily:
                            "Montserrat, 'Open Sans', Helvetica, Arial, sans-serif",
                        }}
                      >
                        Formulary:{" "}
                      </b>{" "}
                      <span
                        class="text-secondary"
                        style={{
                          fontWeight: 500,
                          fontFamily:
                            "Montserrat, 'Open Sans', Helvetica, Arial, sans-serif",
                        }}
                      >
                        Un
                      </span>
                    </li>
                    <li
                      class="nav-item"
                      style={{
                        padding: 5,
                        fontWeight: 500,
                        fontFamily:
                          "Montserrat, 'Open Sans', Helvetica, Arial, sans-serif",
                      }}
                    >
                      View Coverage
                    </li>
                  </ul>{" "}
                </div>
              </nav>
              <nav
                class="navbar navbar-expand-lg border   navbar-primary bg-white "
                style={{
                  marginLeft: "-16px",
                  minWidth: "100.3%",
                  borderBottom: "none",
                }}
              >
                <div class="collapse navbar-collapse" id="navbarNav">
                  <ul
                    class="navbar-nav offset-10 position-relative"
                    style={{ fontSize: "13px", right: "0px" }}
                  >
                    <li class="nav-item " style={{ marginTop: "-2px" }}>
                      <Checkbox
                        className={
                          this.state.value.alternativeMedication !== "NA" &&
                          "clickable2"
                        }
                        type="checkbox"
                        value=""
                        disabled={
                          this.state.value.alternativeMedication === "NA"
                        }
                        onChange={
                          this.state.value.alternativeMedication !== "NA"
                            ? () =>
                                this.setState({ check4: !this.state.check4 })
                            : () => {}
                        }
                      />
                      {/* onChange={this.handleChange} */}
                    </li>
                    <li class="nav-item ms-2">
                      <div
                        class="nav-link text-dark"
                        style={{
                          width: "32px",
                          height: "35px",
                          marginTop: "-3px",
                          fontSize: "20px",
                        }}
                      >
                        <i
                          class="far fa-money-bill-alt"
                          style={{
                            color:
                              this.state.value.alternativeMedication !== "NA"
                                ? "#008576"
                                : "e7e7e7",
                          }}
                        ></i>
                      </div>
                    </li>
                    <li class="nav-item ms-3">
                      <div
                        class="nav-link "
                        style={{
                          color:
                            this.state.value.alternativeMedication !== "NA"
                              ? "#008576"
                              : "e7e7e7",
                          fontSize: "10px",
                          fontWeight: 500,
                          marginLeft: "7px",
                          fontFamily:
                            "Montserrat, 'Open Sans', Helvetica, Arial, sans-serif",
                        }}
                      >
                        Coupon/guide <br />
                        Available
                      </div>
                    </li>
                  </ul>
                </div>
              </nav>
            </div>
          </section>
          <div
            class="col-md-12 mt-3 "
            style={{ paddingBottom: "20px", textAlign: "right" }}
          >
            <Button
              className="button5"
              height="fit-content"
              borderRadius="20px"
              style={{
                height: "30px",
                padding: "2px 27px",
                marginTop: "-6px",
                fontSize: "13.5px",
                marginLeft: "8px",
                backgroundImage:
                  "linear-gradient(315deg, #7f7f7f 0%, #9e9e9e 74%)",
                color: "white",
                fontWeight: 600,
                textAlign: "center",
                boxShadow: "5px 5px 10px 1px grey",
              }}
              onClick={this.update}
            >
              Update
            </Button>
            <Button
              height="fit-content"
              borderRadius="20px"
              style={{
                height: "30px",
                padding: "2px 27px",
                marginTop: "-6px",
                fontSize: "13.5px",
                marginLeft: "28px",
                marginRight: "0%",
                backgroundImage:
                  "linear-gradient(315deg, #7f7f7f 0%, #9e9e9e 74%)",
                color: "white",
                fontWeight: 600,
                textAlign: "center",
              }}
            >
              Close
            </Button>
          </div>
        </div>
        {/* <div style={{ width: "25%" }}>
          <iframe
            style={{ height: "728px", width: "100%" }}
            srcDoc={this.props.verticalCreative}
          />
        </div> */}
      </div>
    );
  }
}
//Billing;
